import Modal from './../components/BsModal.vue'
import PaymentContainerBraintree from '../components/Checkout/PaymentContainer.vue'
import PaymentContainerStripe from '../../../shared/js/components/StripePaymentContainer.vue'
import Helpers from '../../../shared/helpers'
import HideDigiohIntentMixin from "../mixins/digioh-intent-mixin.js";
import RecaptchaChallengeMixin from "../../../shared/js/mixins/recaptcha-challenge-mixin.js";

Vue.component('page-checkout', {

	components: {
		Modal,
		PaymentContainerBraintree,
		PaymentContainerStripe,
	},

	mixins: [Helpers, HideDigiohIntentMixin, RecaptchaChallengeMixin],

	computed: {

		fraudData: function () {
			return window.fraud_data;
		},

		displayCredits() {
			if (!this.customer) {
				return false
			}

			if (!this.customer.credits) {
				return false
			}

			if (parseFloat(this.credits) >= parseFloat(this.customer.credits)) {
				return false
			}

			return true
		},

		allowedCredits() {
			if (!this.customer || !this.customer.credits) {
				return 0
			}

			return this.customer.credits
		},

		maxAllowedCredits() {
			if (!this.customer || !this.customer.credits) {
				return 0
			}

			if (this.pricing.pay_now < this.customer.credits) {
				return this.pricing.pay_now_usd
			}
			return this.customer.credits
		}

	},

	watch: {
		coupon() {
			this.modalError = false
			this.modalErrorMessage = ''
		},

		billing: {
			handler: function () {
				let debouncedFunction = _.debounce(this.addBillingToSession.bind(this), 1000)
				debouncedFunction()
			},
			deep: true
		}
	},

	data: function () {
		return {
			showSummary: true,
			blackoutError: false,

			searchbox: {},

			expand_taxes: false,
			working: false,
			loading: false,
			parkGuardLoading: false,

			modalErrorMessage: '',
			modalError: false,

			showCreditsForm: false,
			use_credits: null,

			terms_url: apr.terms_url,
			privacy_url: apr.privacy_url,
			park_guard_terms_url: apr.park_guard_terms_url,
			park_guard_claim_url: apr.park_guard_claim_url,

			displayParkingPerson: false,

			showCouponForm: false,
			coupon: apr.coupon,
			coupon_code: null,
			park_guard_selected: apr.park_guard_selected || false,
			header_title: 'Guest details',
			customer_id: null,
			step: 1,
			customer: {},
			credits: apr.credits,
			billing: {
				email: '',
				firstname: '',
				lastname: '',
				zipcode: '',
				phone: '',
				license_plate: '',
			},
			card: {
				gateway_data: null
			},
			meta_data: {
				request_id: '',
				fraud_chance: '',
			},

			deviceData: null,

			search: apr.search,
			pricing: apr.pricing,
			parkinglot: apr.parkinglot,
			product: apr.product,

			errors: [],
			errorNoTimes: null,
			errorMessage: null,

			months: apr.months,
			years: apr.years,

			clone_search: {},

			times: apr.times,

			newsletter: true,
			sms: true,
			submitReservationDisabled: true,
			recaptchaToken: null,
			recaptchaChallengeToken: null,
		}
	},

	mounted() {
		this.fireDataLayerEvents();

		let self = this

		this.$root.$on('session-received', function (data) {

			if (data.login.id) {
				self.step = 2
				self.header_title = 'Customer details'
				self.customer_id = data.login.id
				self.customer = data.customer

				//dataLayer - checkout step3 - Set Email
				let category = self.getLotCategory(apr.parkinglot.provider);
				let totalPrice = parseFloat(apr.pricing.total_str.replace("$", ""));
				let serviceFee = parseFloat(apr.pricing.servicefee_str.replace("$", ""));
				let taxesAndFess = apr.pricing.taxes_and_fess_total;
				let countDays = parseInt(apr.pricing.explanation);
				let price = parseFloat(((totalPrice - serviceFee - taxesAndFess)/countDays).toFixed(2));
				dataLayer.push({
					'event': 'checkout',
					'ecommerce': {
						'checkout': {
							'actionField': {'step': 3, 'option': 'Customer Details'},
							'products': [{
								'name': `${apr.search.airport.data.code} ${apr.parkinglot.name}`,
								'id': apr.parkinglot.id,
								'price': price,
								'brand': '',
								'category': category,
								'variant': '',
								'quantity': 1
							}]
						}
					}
				})
			}

			if (apr.billing) {
				self.billing = apr.billing
				self.clearLicensePlateIfNotRequired()
			}
		})

		if (apr.billing) {
			self.clearLicensePlateIfNotRequired()
		}

		this.$root.$on('gateway-changed', (data) => {
			this.card = data
		});

		this.$root.$on('payment-container::verification-failed', (errorMessage = null) => {
			if (errorMessage) {
				this.errorMessage = errorMessage;
			}

			$('button').prop('disabled', false);
			this.loading = false;
		});

		$('#Add_Coupon, #Add_Credits').on('hidden.bs.modal', function (e) {
			if (self.modalError) {
				this.cleanMessages()
				self.coupon = null
				self.credits = null
			}
		});

		$('#Edit_Times').on('hidden.bs.modal', function (e) {
			self.dismissTimesModal()
		});

		$('[data-toggle="popover"]').popover({
			html: true,
		});

		this.$root.$on(`checkout::credit-card-was-validated`, () => {
			if (apr.google_recaptcha_enabled) {
				grecaptcha.enterprise.ready(function() {
					grecaptcha.enterprise.execute(apr.google_recaptcha_site_key, {action: 'submit'}).then(function(token) {
						self.recaptchaToken = token;

						self.onValidatedCard();
					});
				});
			} else {
				self.onValidatedCard();
			}
		});

		if (this.$ldClient && this.$ldClient.client) {
			this.$ldClient.client.waitUntilReady().then(() => {
				this.$ldClient.client.track('begin_checkout');
			});
		}
	},

	methods: {
		clearLicensePlateIfNotRequired() {
			if (!this.parkinglot || !this.parkinglot.require_license_plate || this.parkinglot.require_license_plate != 1) {
				this.billing.license_plate = null;
			}
		},

		fireDataLayerEvents() {
			let airportCode = apr.search.airport.data.code;
			dataLayer.push({ecommerce: null});
			dataLayer.push({
				event: 'begin_checkout',
				ecommerce: {
					currency: 'USD',
					value: this.pricing.pay_now_usd || null,
					coupon: this.search.coupon || null,
					items: [
						{
							item_id: this.parkinglot.id || null,
							item_name: `${airportCode} ${this.parkinglot.name}`,
							coupon: this.search.coupon || null,
							discount: this.pricing.discount,
							index: 0,
							item_brand: this.parkinglot.name || null,
							item_category: 'Airport Parking Only',
							item_category2: null,
							item_category3: null,
							item_category4: null,
							item_category5: null,
							item_variant: 'available',
							price: this.pricing.pay_now_usd || null,
							quantity: 1
						}
					]
				}
			});
		},

		showTimesModal() {
			this.clone_search = (JSON.parse(JSON.stringify(this.search)));
			$('#Edit_Times, #Select_Parking').modal('show')
		},

		dismissTimesModal() {
			for (const prop in this.clone_search) {
				if (this.clone_search[prop] != this.search[prop]) {
					this.search[prop] = this.clone_search[prop];
				}
			}
		},

		checkInput(e) {
			const NO_NUMBERS_ALLOWED_CHARS_REGEXP = /^([^0-9]*)$/;
			if (!NO_NUMBERS_ALLOWED_CHARS_REGEXP.test(e.key)) {
				e.preventDefault();
			}
		},
		submitReservation() {
			$('button').prop('disabled', true);
			this.loading = true;
			this.checkFraudChance(this.fraudData);
			let self = this;

			self.makeReservation(self);
		},

		makeReservation(self) {
			self.$root.$emit('checkout::reservation-submitted', self.card);
			self.triggerCheckoutEvent('Complete Reservation')
		},

		onValidatedCard() {
			this.$http.post(apr.complete_reservation_link, {
				billing: {
					...this.billing,
					license_plate: (this.parkinglot && this.parkinglot.require_license_plate == 1)
						? (this.billing.license_plate || '')
						: '',
				},
				card: this.card,
				meta_data: this.meta_data,
				park_guard_selected: this.park_guard_selected,
				newsletter: this.newsletter,
				sms: this.sms,
				recaptchaToken: this.recaptchaToken,
				recaptchaChallengeToken: this.recaptchaChallengeToken,
			}).then((response) => {

				if (_.get(response, 'body.status') === 'requires_action') {
					this.$root.$emit('checkout::additional-actions-required', _.get(response, 'body.data'));
					this.loading = false;

					return;
				}

				if (response.body.id) {
					//dataLayer - checkout step4 - Payment Method
					let category = this.getLotCategory(this.parkinglot.provider);
					let totalPrice = parseFloat(apr.pricing.total_str.replace("$", ""));
					let serviceFee = parseFloat(apr.pricing.servicefee_str.replace("$", ""));
					let taxesAndFess = apr.pricing.taxes_and_fess_total;
					let countDays = parseInt(apr.pricing.explanation);
					let price = parseFloat(((totalPrice - serviceFee - taxesAndFess)/countDays).toFixed(2));
					dataLayer.push({
						'event': 'checkout',
						'ecommerce': {
							'checkout': {
								'actionField': {'step': 4, 'option': 'Payment Method'},
								'products': [{
									'name': `${apr.search.airport.data.code} ${apr.parkinglot.name}`,
									'id': apr.parkinglot.id,
									'price': price,
									'brand': '',
									'category': category,
									'variant': '',
									'quantity': 1
								}]
							}
						}
					})

					window.location.href = response.body.receipt_url
				} else {
					this.loading = false
				}

			}, (response) => {
				if (this.maybeHandleRecaptchaChallenge(response)) {
					$('button').prop('disabled', false);
					this.loading = false;
					return;
				}

				// Not a captcha step-up: a solved challenge token is single-use and now
				// spent - drop it so a manual retry falls back to a fresh invisible token.
				this.recaptchaChallengeToken = null;

				if (response.body.errors) {
					this.errors = response.body.errors

					if (this.errors.error !== undefined) {
						dataLayer.push({
							'event': 'GaEvent',
							'EventCategory': 'Checkout',
							'EventAction': 'Payment Gateway Error',
							'EventLabel': JSON.stringify(response.body.errors)
						});
						$("#modal-errors").modal("show")
					} else {
						dataLayer.push({
							'event': 'GaEvent',
							'EventCategory': 'Checkout',
							'EventAction': 'Validation error',
							'EventDetails': JSON.stringify(this.errors),
						});

						console.log(JSON.stringify(this.errors));
					}
				}

				if (response.body.error) {
					this.errorMessage = response.body.error[0]
					this.$root.$emit('payment-container::reset', this.card);

					dataLayer.push({
						'event': 'GaEvent',
						'EventCategory': 'Checkout',
						'EventAction': 'Payment Gateway Error',
						'EventLabel': JSON.stringify(response.body.error)
					});
				}

				if (_.get(response, 'body.stripe_data')) {
					this.$root.$emit('checkout::payment-intent-updated', _.get(response, 'body.stripe_data'));
				}

				$('button').prop('disabled', false);
				this.loading = false
			})
		},

		updateTimes() {
			this.working = true
			this.errorTimes = false
			this.blackoutError = false
			this.$http.post(apr.update_reservation_link, {
				checkintime: this.search.checkintime.default,
				checkouttime: this.search.checkouttime.default,
				checkindate: this.search.checkindate.date_format_1,
				checkoutdate: this.search.checkoutdate.date_format_1,
			}).then((response) => {
				if (_.get(response, 'body.stripe_data')) {
					this.$root.$emit('checkout::payment-intent-updated', _.get(response, 'body.stripe_data'));
				}

				$('#Edit_Times').modal('hide')
				this.updatePage(response)
				this.showSummary = true
			}, (response) => {
				this.showSummary = false
				if (_.get(response, 'body.data.error') === 'times') {
					this.errorTimes = true
					this.errorCheckInTime = response.body.data.checkin
					this.errorCheckOutTime = response.body.data.checkout
				} else if (_.get(response, 'body.errors')) {
					this.errorTimes = true
					this.errorCheckInTime = _.get(response, 'body.errors.checkintime[0]')
					this.errorCheckOutTime = _.get(response, 'body.errors.checkouttime[0]')

					this.errors = _.reduce(_.get(response, 'body.errors', {}), function(result, value, key) {
						result.error.push(value[0]);
						return result;
					}, {error: []});
					$("#modal-errors").modal("show")
				} else {
					this.blackoutError = true
				}
				this.working = false
			})
		},

		nextStep() {
			if (this.isValidEmail()) {
				this.$http.post(apr.abandoned_cart_link, {email: this.billing.email, newsletter: this.newsletter})
				this.step++
				this.errors = []

				//dataLayer - checkout step3 - Set Email
				let category = this.getLotCategory(this.parkinglot.provider);
				let totalPrice = parseFloat(apr.pricing.total_str.replace("$", ""));
				let serviceFee = parseFloat(apr.pricing.servicefee_str.replace("$", ""));
				let taxesAndFess = apr.pricing.taxes_and_fess_total;
				let countDays = parseInt(apr.pricing.explanation);
				let price = parseFloat(((totalPrice - serviceFee - taxesAndFess)/countDays).toFixed(2));
				dataLayer.push({
					'event': 'checkout',
					'ecommerce': {
						'checkout': {
							'actionField': {'step': 3, 'option': 'Customer Details'},
							'products': [{
								'name': `${apr.search.airport.data.code} ${apr.parkinglot.name}`,
								'id': apr.parkinglot.id,
								'price': price,
								'brand': '',
								'category': category,
								'variant': '',
								'quantity': 1
							}]
						}
					}
				})
			} else {
				this.errors = {'billing.email': 'Invalid email address.'}
			}
		},

		addBillingToSession() {
			this.$http.post(apr.add_billing_link, {billing: this.billing})
		},

		updatePage(response, onComplete = null) {
			setTimeout(() => {
				this.search = response.body.search
				this.pricing = response.body.pricing
				this.coupon = response.body.coupon
				this.park_guard_selected = _.get(response, 'body.pricing.park_guard_selected', this.park_guard_selected)
				this.park_guard_terms_url = _.get(response, 'body.pricing.park_guard_terms_url', this.park_guard_terms_url)
				this.park_guard_claim_url = _.get(response, 'body.pricing.park_guard_claim_url', this.park_guard_claim_url)
				this.cleanMessages()
				this.working = false

				if (typeof onComplete === 'function') {
					onComplete()
				}
			}, 1500)
		},

		applyParkGuard() {
			const selected = this.park_guard_selected

			this.parkGuardLoading = true
			this.$http.post(apr.add_park_guard_link, {selected}).then((response) => {
				this.updatePage(response, () => {
					this.parkGuardLoading = false
				})
			}, () => {
				this.parkGuardLoading = false
				this.park_guard_selected = !selected
				this.modalErrors('Sorry we are unable to update Park Guard right now.')
			})
		},

		applyCoupon() {

			if (this.coupon_code) {

				this.working = true
				this.$http.post(apr.add_coupon_link, {code: this.coupon_code}).then((response) => {
					this.coupon = this.coupon_code
					this.updatePage(response)
					dataLayer.push({
						'event': 'GaEvent',
						'EventCategory': 'Coupon',
						'EventAction': 'Success',
						'EventLabel': this.coupon_code
					})
				}, (response) => {
					this.modalErrors('Sorry that is an invalid coupon code')
					dataLayer.push({
						'event': 'GaEvent',
						'EventCategory': 'Coupon',
						'EventAction': 'Failed',
						'EventLabel': this.coupon_code
					})
				})

				return
			}

			this.modalErrors('Please enter a coupon code')
		},

		applyCredits() {

			if (parseFloat(this.use_credits) > parseFloat(this.maxAllowedCredits)) {
				this.modalErrors('You tried to add more than maximum credits.');
				return;
			}
			if (this.use_credits) {
				this.working = true
				this.$http.post(apr.add_credits_link, {credits: this.use_credits}).then((response) => {
					this.updatePage(response)
					this.credits = this.use_credits
				}, (response) => {
					this.modalErrors('Sorry we are unable to add your credits.')
				})

				return
			}

			this.modalErrors('Please enter a credit amount you would like to use.')

		},

		cleanMessages() {
			this.working = false
			this.modalError = false
			this.modalErrorMessage = ''
		},

		modalErrors(message) {
			this.working = false
			this.modalError = true
			this.modalErrorMessage = message
		},

		isValidEmail() {
			return /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(this.billing.email);
		},

		checkFraudChance(fraud_data) {
			if (!apr.device_fingerprint.enabled) {
				return;
			}

			let redirectPath = '/';

			if (typeof fraud_data !== "undefined" && fraud_data.request_id !== '' && fraud_data.fraud_chance !== '') {
				if (fraud_data.fraud_chance >= apr.device_fingerprint.fraud_mark) {
					window.location.href = redirectPath;
				}

				this.meta_data.request_id = String(fraud_data.request_id);
				this.meta_data.fraud_chance = String(fraud_data.fraud_chance);
			} else {
				window.location.href = redirectPath;
			}
		},

		triggerCheckoutEvent(action, label = '') {
			dataLayer.push({
				'event': 'GaEvent',
				'EventCategory': 'Checkout',
				'EventAction': action,
				'EventLabel': label
			});
		},

		toggleCoupon() {
			this.showCouponForm = !this.showCouponForm
		},

		toggleCredits() {
			this.showCreditsForm = !this.showCreditsForm
		},

		searchPath() {
			window.location.href = `/search/${this.search.airport.data.code}?token=${this.search.token}`
		},

		// checkoutLink(response)
		// {
		//     return response.receipt_url
		//     // return `/receipt/${response.body.id}/${response.body.receipt_token}`
		// },

		clearErrors(name) {
			this.errors[name] = null
		},

	}
});
